import axiosInstance from "../utils/axios";

export const GetBanner = async (value) => {
    return axiosInstance().get("/getBanner",{params: value});
};

